import { invokeApi } from "../../bl_libs/invokeApi";

export const _general_setting = async (data) => {
    const requestObj = {
      path: `api/website_settings/get_general_settings`,
      method: "GET",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    return invokeApi(requestObj);
  };
  export const _add_general_settings = async (data) => {
    const requestObj = {
        path: `api/website_settings/add_general_settings`,
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
      postData: data,
    };
    return invokeApi(requestObj);
  };